<template>
    <div    class="doc-detail-mobile ">
        <div class="top flex flex-col padding-l ">
            <div class="flex flex-space-between">
                <div class="font-l font-bold">{{docData.name}}</div>
                <div @click="ver($event)">
                    <span v-if="docData.files != null && docData.files.length>1" class="color-blue font-l">选版本</span>
                </div>
            </div>

            <div class="font-s margin-top-m ">
                <span class="color-gold">{{docData.userName}}</span>于
                <span>{{docData.createTime}}</span>创建  
                <span v-if="docData.files != null && docData.files.length>1" style="margin-left: 40px;">当前版本:</span>
                <span v-if="docData.files != null && docData.files.length>1">{{fileUserName}}</span>
            </div>
        </div>
        <vue-custom-scrollbar  class="body padding-l scroll ">
            <div  v-html="docData.content"> 
            </div>
        </vue-custom-scrollbar>

        <div class="bottom flex flex-center-cz padding-left-l padding-right-l flex-center-sp ">
            <div>
                <span class="margin-right-l font-s color-gray">点赞({{docData.likeCount}})</span>
                <span class="margin-right-l font-s color-gray">浏览({{docData.viewCount}})</span>
                <span class="margin-right-l font-s color-gray">评论({{docData.commentCount}})</span>
                <span class="margin-right-l font-s color-gray">收藏({{docData.collectCount}})</span>
            </div>
        </div>

        <popup-menu ref="opMenu" :menuData="opMenuData"  @menuClick="opMenuClick"></popup-menu>

    </div>
</template>

<script>

    import { getFileByShareId,getFileList} from '@/api/api.js';
    import {getJsDateTime} from '@/utils/dateUtils.js'
    import {strToInt} from '@/utils/sysUtils.js'
    import PopupMenu from '@/components/popupMenu/PopupMenu' 

    export default{
        name:'',
        components:{PopupMenu},
        data() {
            return {
                bizType: 1,
                shareId: null,
                docId: null,
                commentData: null,
                docData: {},
                fileUserName: null,
                token: sessionStorage.getItem("token"),
                userId: sessionStorage.getItem("userId"),
                opMenuData: [
    
                ],
            }
        },
        created() {
            this.shareId = this.$route.query.shareId;
            this.getFileInfo(this.shareId);
        },
        methods:{
            getFileInfo(shareId) {
                this.$showLoading();
                getFileByShareId(shareId).then((res) => {
                    this.docData = res.data.result;
                    this.docData.createTime = getJsDateTime(this.docData.createTime);
                    this.docData.likeCount = strToInt(this.docData.likeCount);
                    this.docData.viewCount = strToInt(this.docData.viewCount);
                    this.docData.commentCount = strToInt(this.docData.commentCount);
                    this.docData.collectCount = strToInt(this.docData.collectCount);
                    this.docId =  this.docData.id;
                    this.docData.files.forEach(item => {
                        item.createTime = getJsDateTime(item.createTime) 
                        if (item.userId == this.docData.userId) {
                            this.fileUserName = item.userName;
                        }            
                    });

                    this.$forceUpdate();
                    this.$closeLoading();  
                    console.log(res.data.result);
                }) 
            },

            getFiles(docId){
                getFileList(docId).then((res) => {
                    this.docData.files = res.data.result;
                }) 
            },
            ver(event) {
                this.opMenuData = [];
                this.docData.files.forEach(item => {
                    this.opMenuData.push({id:item.id, name:item.userName});            
                });
                console.log("opMenuData", this.opMenuData);
                this.$refs.opMenu.show(event);//
            },
            opMenuClick(id) {
                console.log("====",id)
                this.docData.fileId = id;
                this.docData.files.forEach(item => {
                    if (item.id == id) {
                        this.fileUserName = item.userName
                        this.docData.content = item.content;
                    }             
                });
                
            }
        }
    }
</script>

<style scoped>


    .body >>> img {
        max-width: 100% ;
        display:block;
        object-fit: contain; /* 将图像等比例地调整到完全包裹容器 */
    }

   .doc-detail-mobile {
       width: 100%;
   }

   .doc-detail-mobile .top {
        position: fixed;
        left:0;
        right: 0;
        top: 0;
        height: 60px;
        z-index: 999;
   }

   .doc-detail-mobile .body {
        position: fixed;
        padding-top: 20px;
        left:0;
        right: 0;
        top: 60px;
        bottom: 40px;
   }


   .doc-detail-mobile .bottom {
       position: fixed ;
       left:0;
       right: 0;
       bottom: 0;
       height: 40px;
       background-color: #fff;
       border-top: 1px solid rgba(0, 0, 0, .2);
   }
</style>


// WEBPACK FOOTER //
// src/views/mobile/DocDetail.vue